import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { StatusType } from '../models/status-type';
import { JsonHttpService } from '../../shared/http/json-http.service'

@Injectable({
  providedIn: 'root'
})
export class StatusTypeService {
  private httpService = inject(JsonHttpService);

  getStatusTypes(): Promise<StatusType[]> {
    return firstValueFrom(this.httpService.get('/api/tracking/statustypes/get-document-status-types'));
  }
}
